import { render, staticRenderFns } from "./IntersectIcon.vue?vue&type=template&id=6723acb4&"
import script from "./IntersectIcon.vue?vue&type=script&lang=js&"
export * from "./IntersectIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports